$(document).ready(function () {
  $(".popup-with-zoom-anima").magnificPopup({
    type: "inline",

    fixedContentPos: false,
    fixedBgPos: true,

    overflowY: "auto",

    closeBtnInside: true,
    preloader: false,

    midClick: true,
    removalDelay: 300,
    mainClass: "my-mfp-zoom-in",
  });
  $(".ipl_tabs li").click(function () {
    $(".ipl_tabs li").removeClass("active_tab");
    $(".ipl_tabs_content li").removeClass("active_tab");
    $(this).addClass("active_tab");
    var h_active_tab = $(this).data("tab");
    $(".ipl_tabs_content li").each(function () {
      var b_tab = $(this).data("tab");
      if (b_tab == h_active_tab) {
        $(this).addClass("active_tab");
      }
    });
    var sel_tab = $(this).text();
    $(".mobile_ih_title span").text(sel_tab);
  });

  if ($(window).width() < 990) {
    $(".footer-block__details-content").hide();
    $(".footer-block .footer-block__heading").click(function () {
      // $('.footer-block .footer-block__heading').removeClass("open-acc");
      // $(this).toggleClass("open-acc");

      $(this)
        .toggleClass("open-acc")
        .next(".footer-block__details-content")
        .slideToggle()
        .parent()
        .siblings()
        .find(".footer-block__details-content")
        .slideUp()
        .prev()
        .removeClass("open-acc");
    });
  }

  let mybutton = document.querySelector(".sticky-button-wrapper");
  let height = $(".product-section").outerHeight();
  let element = $(".product-section");

  window.onscroll = function () {
    scrollFunction();
  };
  function scrollFunction() {
    if (mybutton) {
      if (
        document.body.scrollTop > height ||
        document.documentElement.scrollTop > height
      ) {
        mybutton.style.cssText = `
        visibility: visible;
        opacity: 1;
      `;
      } else {
        mybutton.style.cssText = `
        visibility: hidden;
        opacity: 0;
      `;
      }
    }
  }
  $("#scrollTop").click(function () {
    $("html, body").animate(
      {
        scrollTop: $(".product__info-container").offset().top,
      },
      500
    );
  });
});

$(document).on("change", ".variant_options input[type='radio']", function () {
  var selectedVariantPrice = parseFloat($(this).data("price")) || 0;
  var moneyFormat = $("body").data("money-format");

  if (!isNaN(selectedVariantPrice)) {
    var dividedPrice = selectedVariantPrice / 4;
    //$(".atc--pricess").html(formatMoney(dividedPrice, moneyFormat));
  }

  // if($('.buy_more-main').length > 0){
  //   setTimeout(function () {
  //     var o_p = $(".buy_more-main .radio input[type=radio]:checked+label .option_price").html();
  //    $(".product__info-container .price").html(o_p);
  //          }, 1100);
  //        }
});

// $(document).on('change', ".variant_options", function(){
//   setTimeout(function () {
// var price = $(".optionPrice").text();
//     $(this ".optionPrice").text(price);
//       }, 1500);
// });

// $(document).on('change', ".variant_options", function(){
//     setTimeout(function () {
//         $(".optionPrice.priceChange").each(function() {
//             var price = $(this).data('price');
//             $(this).text(price);
//         });
//     }, 1500);
// });

// $(document).on('change', ".variant_options", function(){
//     setTimeout(function () {
//         var selectedVariantPrice = $(".price-item--sale.main-price").text();
//         $(".optionPrice.priceChange").each(function() {
//             var basePrice = $(this).data('price');
//             var newPrice = calculateNewPrice(basePrice, selectedVariantPrice);
//             $(this).text(newPrice);
//         });
//     }, 1500);
// });
// function calculateNewPrice(basePrice, selectedVariantPrice) {
//     return basePrice;
// }

// $(document).on('change', ".variant_options", function(){
//     setTimeout(function () {
//         var selectedVariantPrice = $(".price-item--sale.main-price").text();
//         $(".optionPrice.priceChange").each(function() {
//             var basePrice = $(this).data('price');
//             var newPrice = parseFloat(basePrice) + parseFloat(selectedVariantPrice);
//             $(this).text(newPrice.toFixed(2)); // Display the new price with two decimal places
//         });
//     }, 1500);
// });

$(document).on("change", ".variant_options", function () {
  setTimeout(function () {
   var has_bundle = document.querySelector("moonbundle-component");
   if(has_bundle){
    var mainPrice = document.querySelector(".price-item--sale.main-price");
    var sectedBundlePrice = document.querySelector(".moonbundle-option.moonbundle-option-active .moonbundle-option-price .moonbundle-option-single-price").innerText;
    mainPrice.innerText = sectedBundlePrice;
   }

    var price = $(".price-item--sale.main-price").text();
    //var ATC_text = $(".atc--price").data("atc-text");
    //$(".atc-button").first("span").text(ATC_text);
    $(".atc--price").text(price);    
  }, 1500);
});

// if ($(".buy_more-main").length > 0) {
//   $(".atc-button").addClass("addToCartMore");
//   // $('.add-to-cart').removeClass("add-to-cart");
// }
// $(document).on("click", ".addToCartMore", function (e) {
//   e.preventDefault();
//   var productIds = $('input[name="buyMoreOptions"]:checked').data("products");
//   var currentProduct = $('input[name="buyMoreOptions"]:checked').data(
//     "currentproduct"
//   );
//   var selectedOptionValue = $(this)
//     .closest("form")
//     .find('input[name="id"]')
//     .val();

  
//   //alert(productIds);
//   //alert(selectedOptionValue)
//   var products = [];
//   products.push({ productId: selectedOptionValue });
//   // Split the product IDs by comma
//   if (productIds != "") {
//     if ($.inArray(",", productIds) !== -1) {
//       var productIdArray = productIds.split(",");

//       // Create objects with productId property for each ID
//       $.each(productIdArray, function (index, productId) {
//         productID = parseInt(productId, 10);
//         products.push({ productId: productID });
//       });
//     } else {
//       productID = productIds.toString();
//       products.push({ productId: productID });
//     }
//   }
//   // Output the resulting array
//   console.log(products);
//   // Define the products you want to add to the cart

//   // Create an array to store the line items
//   var lineItems = [];

//   // Loop through each product and create line item objects
//   $.each(products, function (index, product) {
//     var lineItem = {
//       id: String(product.productId).replace(/\s+/g, ""), // Remove spaces from product ID
//       quantity: 1,
//     };

//     lineItems.push(lineItem);
//   });

//        // Get the toggle checkbox after it's created
//   // let toggleCheckbox = document.getElementById('sub_toggle');
//   // if(toggleCheckbox){
//   //   let isChecked = toggleCheckbox.checked;
//   // }
  

//   // Send Ajax request to add the line items to the cart

//   $.ajax({
//     url: "/cart/add.js",
//     method: "POST",
//     dataType: "json",
//     data: {
//       items: lineItems,
//     },
//     success: function (response) {
//       // Handle success response
//       console.log("Products added to cart successfully");
      
//      //showProduct();

      
//       // Store the variant ID for later use
//       //const upsellId = $(".sub_product-card").data("var-id");
      
//       // Add event listener to the toggle checkbox
//       // if (toggleCheckbox) {
        
//       //  upsellAddToCart(upsellId, isChecked);
//       //  }
//     },
//     error: function (xhr, status, error) {
//       // Handle error response
//       console.log("Error adding products to cart:", error);
//     },
//   });
// });

// $(".slider-filter").slick({
//   dots:true,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: true,
//   centerMode:false,
//   prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//   nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
// });

//product stat slider - class of the slider has been overwrited from product_stats to product_statss
$(".product_status").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  centerMode: false,
  prevArrow:
    '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  nextArrow:
    '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
if ($(window).width() < 990) {
  // $(".product_stats").slick('unslick');
  $(".template--customers-account .account-header-main li:first-child").click(
    function () {
      $(".account-header-main li:not(:first-child)").slideToggle();
      $(".account-header-main ul").toggleClass("active-nav");
    }
  );
  $(".template-order-history .account-header-main li:last-child").click(
    function () {
      $(
        ".template-order-history .account-header-main li:not(:last-child)"
      ).slideToggle();
      $(".template-order-history .account-header-main ul").toggleClass(
        "active-nav"
      );
    }
  );
}

// $(".filter li").on('click', function(){
//   var filter = $(this).data('filter');
//   $(".filter li").removeClass("active");
//   $(this).addClass("active");
//   $(".slider-filter").slick('slickUnfilter');

//   if(filter == 'tab_1'){
//     $(".slider-filter").slick('slickFilter','.tab_1');
//   }
//   else if(filter == 'tab_2'){
//     $(".slider-filter").slick('slickFilter','.tab_2');
//   }
//   else if(filter == 'tab_3'){
//     $(".slider-filter").slick('slickFilter','.tab_3');
//   }

// })

// $(".filter li[data-filter='tab_1']").addClass("active");

// $(".filter li").on('click', function(){
//     var filter = $(this).data('filter');

//     $(".filter li").removeClass("active");
//     $(this).addClass("active");

//     $(".slider-filter").slick('slickUnfilter').slick('slickFilter', '.' + filter);
// });

$(document).ready(function () {
  // Initialize Slick Slider with custom arrows
  var $slider = $(".slider-filter").slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    centerMode: false,
    prevArrow:
      '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  });

  // Tab click event
  $(".filter li").on("click", function () {
    var filter = $(this).data("filter");
    $(".filter li").removeClass("active");
    $(this).addClass("active");
    $slider.slick("slickUnfilter").slick("slickFilter", "." + filter);
  });

  // On slide change, update active tab
  $slider.on("afterChange", function (event, slick, currentSlide) {
    var currentClass = slick.$slides
      .eq(currentSlide)
      .attr("class")
      .split(" ")
      .find((c) => c.startsWith("tab_"));
    $(".filter li").removeClass("active");
    $(".filter li[data-filter='" + currentClass + "']").addClass("active");
  });
});


// Add this script to your theme.liquid file or create a new JS file
function hideSingleSubscription() {
  // Find all subscription dropdown wrappers
  const subscriptionDropdownWrappers = document.querySelectorAll('.upcart-product-item');
  
  subscriptionDropdownWrappers.forEach(wrapper => {
    
    const subs_wrapper = wrapper.querySelector('.upcart-subscription-upgrade-section');
    const dropdown = wrapper.querySelector('.upcart-subscription-upgrade-dropdown');
    const item_title_class = wrapper.querySelector('.upcart-product-title-link');
    const item_title = item_title_class.textContent;
    
    if (dropdown) {
      // Get all optgroups in the dropdown
      const optgroups = dropdown.querySelectorAll('optgroup');
      
      // Check if there's only one subscription plan
      // This checks if there's only one optgroup with label "Subscription plans" AND it only has one option
      let singleSubscriptionPlan = false;
      
      // Look for the subscription plans optgroup
      const subscriptionOptgroup = Array.from(optgroups).find(group => 
        group.label.toLowerCase().includes('subscription')
      );
      
      if (subscriptionOptgroup) {
        const subscriptionOptions = subscriptionOptgroup.querySelectorAll('option');
        
        // If there's only one subscription option and no "one-time purchase" option
        //if (subscriptionOptions.length === 1 && optgroups.length === 1) {
        if(item_title == "Infinity Hoop Community & Workouts") { 
          singleSubscriptionPlan = true;
        }
      }
      
      if (singleSubscriptionPlan) {
        // Get the subscription plan name to display
        const planName = subscriptionOptgroup.querySelector('option').textContent;
        
        // Hide the dropdown wrapper
        subs_wrapper.style.display = 'none';
    
        dropdown.selectedIndex = 0;
      }
    }
  });
}

//to show bundle on cart drawer (upcart app) - starts
const PRODUCT_HANDLE = 'community';

// Function to fetch and display product
function showProduct() {
  const container = document.getElementById('product-display');

  fetch('/products/' + PRODUCT_HANDLE + '.js')
    .then(response => response.json())
    .then(product => {
      const variantId = product.variants[0].id;

      // Display product HTML
      const html = `
        <div class="sub_product-card">
          <img src="${product.featured_image || product.images[0]}" alt="${product.title}" class="sub_product-image">
          <div class="sub_pro-info">
            <div class="sub_pro-heading">
              <h3 class="sub_product-title">${product.title}</h3>
              <span class="sub_pro-description">Free 30 day access</span>
            </div>
            <div class="sub_price">
              <p class="sub_product-price">$${(product.price / 100).toFixed(2)}</p>
              <p class="sub_product-price-free">$0.00</p>
            </div>
          </div>
          <div class="sub_toggle-atc">
            <input name="selling_plan" type="hidden" value="4768727281">
            <div class="sub_toggle-container">
              <input type="checkbox" class="sub_toggle-checkbox" id="sub_toggle">
              <label class="sub_toggle-switch" for="sub_toggle"></label>
              <div id="cart-status" class="sub_cart-status"></div>
              <div class="sub_checkmark">✓</div>
            </div>
          </div>
        </div>
      `;

      container.innerHTML = html;

      const toggleCheckbox = document.getElementById('sub_toggle');

      // Fetch cart to sync checkbox state
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const found = cart.items.find(item => item.variant_id === variantId && item.selling_plan_allocation?.selling_plan.id === 4768727281);
          toggleCheckbox.checked = !!found; // Set initial state

          toggleCheckbox.addEventListener('change', function () {
            upsellAddToCart(variantId, this.checked);
          });
        });
    })
    .catch(error => {
      console.error('Error loading product:', error);
    });
}


// Function to handle product in cart when toggle changes
function upsellAddToCart(variantId, isSubscription) {
  showCartStatus('', 'loading');

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let existingItem = null;
      let lineIndex = -1;

      cart.items.forEach((item, index) => {
        if (item.variant_id === variantId) {
          existingItem = item;
          lineIndex = index + 1; // Shopify line items are 1-based
        }
      });

      if (!isSubscription) {
        // Remove item if present
        if (existingItem) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: lineIndex,
              quantity: 0
            })
          })
          .then(response => response.json())
          .then(cartData => {
            showCartStatus('', 'success');
            updateCartCountFromData(cartData);
            upcartRefreshCart();
          });
        } else {
          showCartStatus('', 'info');
          return Promise.resolve();
        }
      } else {
        // Add item if not present or wrong selling plan
        const correctPlanId = 4768727281;
        if (!existingItem || (existingItem.selling_plan_allocation?.selling_plan.id !== correctPlanId)) {
          const removePromise = existingItem
            ? fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  line: lineIndex,
                  quantity: 0
                })
              }).then(response => response.json())
            : Promise.resolve();

          return removePromise.then(() => {
            const formData = {
              items: [{
                id: variantId,
                quantity: 1,
                selling_plan: correctPlanId
              }]
            };

            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then(data => {
              showCartStatus('', 'success');
              updateCartCount();
              hideSingleSubscription();
              upcartRefreshCart();
            });
          });
        } else {
          showCartStatus('', 'info');
          return Promise.resolve();
        }
      }
    })
    .catch(error => {
      console.error('Error managing cart:', error);
      showCartStatus('Failed to update cart', 'error');
    });
}


// Function to remove item from cart
function removeFromCart(itemKey) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: itemKey,
      quantity: 0
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Failed to remove item');
    }
     upcartRefreshCart();
    return response.json();
   
  });
}

// Helper function to show status messages
function showCartStatus(message, type) {
  const statusElement = document.getElementById('cart-status');
  if (statusElement) {
    statusElement.textContent = message;
    statusElement.className = 'sub_cart-status ' + type;
    
    // Hide after 3 seconds if it's a success, error, or info message
    if (type === 'success' || type === 'error' || type === 'info') {
      setTimeout(() => {
        statusElement.textContent = '';
        statusElement.className = 'sub_cart-status';
      }, 3000);
    }
  }
}

// Updated helper function to update cart count from cart data
function updateCartCountFromData(cartData) {
  // Update any cart count elements on the page
  const cartCountElements = document.querySelectorAll('.cart-count');
  if (cartCountElements.length > 0) {
    cartCountElements.forEach(el => {
      el.textContent = cartData.item_count;
    });
  } else {
    console.warn('No .cart-count elements found on the page');
  }
}

// Helper function to update cart count with a new request
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateCartCountFromData(cart);
    })
    .catch(error => console.error('Error updating cart count:', error));
}

function checkForUpcartFunction() {
  if (typeof window.upcartOnCartOpened === 'function') {
    runUpcartOnCartOpened();
    return;
  }
  const intervalId = setInterval(() => {
    if (typeof window.upcartOnCartOpened === 'function') {
      runUpcartOnCartOpened();
      clearInterval(intervalId);
    }
  }, 500);
}

// Run the check


function runUpcartOnCartOpened(){
  window.upcartOnCartOpened = () => { 
     
   setTimeout(() => {
     //      $.ajax({
     //   type: 'GET',
     //   url: '/cart.js', // Replace with your cart endpoint
     //   dataType: 'json',
     //   success: function(cart) {
     //     // Handle the cart data here
     //     console.log(cart.item_count); // Log the cart object to the console
     //     cart.items.forEach(item => {
     //    console.log("Item:", item.title);

     //    if (item.title.includes("INFINITY HOOP PLUS")) {
     //      //showProduct()
     //      // upsellAddToCart(46086042091761, true);
     //       //break;
     //    }
     //  });
     //   },
     //   error: function(error) {
     //     // Handle errors
     //     console.error(error);
     //   }
     // });
  // upsellAddToCart(46086042091761, true);
     
      // Example toggle logic
     
    //   const toggle = document.querySelector('.styles_ToggleSwitch__');
    //   const circle = document.querySelector('.styles_ToggleSwitch__circle__');
    //  if (!toggle.classList.contains('styles_ToggleSwitch--active__')) {
    //     $(".styles_ToggleSwitch__").click();
    // } 
      // if (toggle) toggle.classList.add('styles_ToggleSwitch--active__');
      // if (circle) circle.classList.add('styles_ToggleSwitch__circle--active__');
    showProduct();
     hideSingleSubscription();
   },1500);
  };
}

// Call the function to show the product when the DOM is ready
 document.addEventListener('DOMContentLoaded', function() {
  checkForUpcartFunction();
  //setTimeout(showProduct, 1000);
  sub_price();
  $(".skio-group-input").click(function(){
  sub_price();
  });

  const pro_title = document.querySelector(".product__title .h1");
    if (pro_title) {
      pro_title.innerHTML = pro_title.innerHTML.replace(
        /™/,
        '<span class="tm-normal">™</span>'
      );
    }
  
});

//to show bundle on cart drawer (upcart app) - ends
function sub_price(){
    var sub_price = $(".skio-group-input:checked").next(".skio-group-label").find(".skio-price").find("span").text();
    $("#regularprice").find("span").text(sub_price)
}

